/**
 * @fileoverview Metrics that go along with schema injection
 *
 * @author Chris Williams (cwilliams@yext.com)
 *
 * We don't use the yext namespace because it clashes with the externs for
 * the analytics library, which is loaded dynamically.
 *
 * BE VERY CAREFUL ABOUT CHANGING THE PARAMETERS IN THIS FILE
 * There is very little validation and data may be silently dropped.
 * Please CC Fusion on any code reviews.
 *
 * Note: The interface of Analytics should be kept in sync with the the NoOpAnalytics class. Please
 *       update the latter if this class changes.
 */
goog.provide('yextschema.Analytics');

goog.require('goog.array');
goog.require('goog.dom');
goog.require('goog.events');
goog.require('goog.object');
goog.require('yext.analytics');
goog.require('yext.pixel');
goog.require('yextschema.helpers');


/**
 * @constructor
 * @param {!Object} data
 */
yextschema.Analytics = function(data) {
  this.businessId = data['businessId'];
  this.partition = data['partition'];
  this.env = data['env'];
  this.entityIdToUid = data['entityIdToUid'];
  this.metricsLibLoaded = false;
  this.pixelOptIn = data['pixelOptIn'];
  this.eventQueue = [];
  /**
   * @type {!Object<string, ?Function>}
   * entityId -> analytics function
   */
  this.yextAnalytics = {};
  this.onLibLoaded_();
};

/**
 * @param {string} eventName
 * @param {string} entityId
 */
yextschema.Analytics.prototype.event = function(eventName, entityId) {
  if (!this.metricsLibLoaded) {
    // Metrics script has not loaded yet, so we put custom events onto a queue.
    this.eventQueue.push([eventName, entityId]);
    return;
  }
  var analyticsFn;
  if (goog.object.getKeys(this.yextAnalytics).length === 1) {
    // Ignore entityId when there's only 1 entity for the page
    analyticsFn = goog.object.getAnyValue(this.yextAnalytics);
  } else {
    analyticsFn = this.yextAnalytics[entityId];
  }
  if (analyticsFn) {
    if (eventName === 'cta_clicks') {
      analyticsFn('calltoactionclick');
    }
    analyticsFn(eventName);
  } else {
    console.error('Event: ' + eventName + ' for invalid entity: ' + entityId);
  }
};

/**
 * Send queued events after analytics library loads
 */
yextschema.Analytics.prototype.drainEventQueue_ = function() {
  while (this.eventQueue.length > 0) {
    this.event.apply(this, this.eventQueue.shift());
  }
};

/**
 * Send queued events after analytics library loads
 */
yextschema.Analytics.prototype.onLibLoaded_ = function() {
  this.metricsLibLoaded = true;
  var requireEntityId = this.entityIdToUid.length !== 1;

  // client-side pixelOptIn should take precedence over server-side pixelOptIn,
  // which is derived by v param.
  var clientPixelQ = window['yPixelOptInQ'] || [];
  if (clientPixelQ.length === 0) {
    if (this.pixelOptIn === true) {
      yext.pixel.optIn(true);
    } else if (this.pixelOptIn === false) {
      yext.pixel.optIn(false);
    }
  } else {
    yext.pixel.checkWindowOptIn();
  }

  /**
   * These parameters are parsed by:
   *   src/com/yext/analytics-js/analytics.js
   *   src/com/yext/ups/tracking/v2/TrackingLogger.java
   *   (and potentially other places, don't let your guard down)
   * There is little to no validation for these fields.
   * If you change them without updating their uses, data may be silently dropped.
   * Please test changes thoroughly and CC Fusion on all code reviews.
   */
  goog.object.forEach(this.entityIdToUid, function(uid, entityId) {
    this.yextAnalytics[entityId] = yext.analytics.getYextAnalytics({
      'product': 'knowledgetags',
      'entity_uid': uid,
      'businessids': this.businessId,
      // partition must be one of the enum values defined in yext.analytics.YextPartition
      // if none is specified then default to us
      'partition': this.partition ? this.partition : yext.analytics.YextPartition.US,
      'env': this.env,
    });

    this.event('pageview', entityId);

    goog.array.forEach(goog.dom.getElementsByClass('yext-cta'), function(element) {
      if (yextschema.helpers.skipElement(element, entityId, requireEntityId)) {
        return;
      }
      goog.events.listen(
        element,
        goog.events.EventType.CLICK,
        function() {
          this.event('calltoactionclick', entityId);
        }.bind(this),
      );
    }.bind(this));

    goog.array.forEach(goog.dom.getElementsByClass('yext-website'), function(element) {
      if (yextschema.helpers.skipElement(element, entityId, requireEntityId)) {
        return;
      }
      goog.events.listen(
        element,
        goog.events.EventType.CLICK,
        function() {
          this.event('clicktowebsite', entityId);
        }.bind(this),
      );
    }.bind(this));

    goog.array.forEach(document.getElementsByTagName('a'), function(element) {
      if (yextschema.helpers.skipElement(element, entityId, requireEntityId)) {
        return;
      }
      var eventName = element.getAttribute('data-ya-track');
      if (eventName) {
        goog.events.listen(
          element,
          goog.events.EventType.CLICK,
          function() {
            this.event(eventName, entityId);
          }.bind(this),
        );
      }
    }.bind(this));
  }.bind(this));

  this.drainEventQueue_();
};
